import { apiClient } from '@/lib/api-client';
import {
  API_ENDPOINTS,
  ContactLog,
  ContactLogRequest,
  PaginatedContactLogList,
} from '@/types/api';

export interface ContactLogListParams {
  ordering?: string;
  page?: number;
  page_size?: number;
  search?: string;
  contact?: number;
  mood?: string;
}

export const contactLogsApi = {
  // List all contact logs
  list: async (params?: ContactLogListParams): Promise<PaginatedContactLogList> => {
    return apiClient.get<PaginatedContactLogList>(API_ENDPOINTS.contactLogs.list, params);
  },

  // Get a specific contact log
  getById: async (id: number): Promise<ContactLog> => {
    return apiClient.get<ContactLog>(API_ENDPOINTS.contactLogs.detail(id));
  },

  // Create a new contact log
  create: async (data: ContactLogRequest): Promise<ContactLog> => {
    return apiClient.post<ContactLog>(API_ENDPOINTS.contactLogs.list, data);
  },

  // Update a contact log
  update: async (id: number, data: ContactLogRequest): Promise<ContactLog> => {
    return apiClient.put<ContactLog>(API_ENDPOINTS.contactLogs.detail(id), data);
  },

  // Partially update a contact log
  partialUpdate: async (id: number, data: Partial<ContactLogRequest>): Promise<ContactLog> => {
    return apiClient.patch<ContactLog>(API_ENDPOINTS.contactLogs.detail(id), data);
  },

  // Delete a contact log
  delete: async (id: number): Promise<void> => {
    return apiClient.delete<void>(API_ENDPOINTS.contactLogs.detail(id));
  },

  // Get all logs for a specific contact
  getByContact: async (contactId: number): Promise<ContactLog[]> => {
    const url = `${API_ENDPOINTS.contactLogs.byContact}?contact_id=${contactId}`;
    const response = await apiClient.get<PaginatedContactLogList>(url);
    return response.results || [];
  },
};
